
import api from '@/api';

const namespaced = true;

const state = {
  users: [],
};

const mutations = {
  SET_USERS(state, users) {
    state.users = users;
  },
};

const actions = {
  async fetchUsers({ commit }) {
    const { data: users } = await api.get(`/users`);
    commit(`SET_USERS`, users);

    return users;
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
